import { gsap } from "gsap";

const DURATION = 0.3;
const EASE = "power2.out";

export const setOpen = (details, isOpen) => {
  if (!details || !("open" in details)) {
    return false;
  }

  details.open = Boolean(isOpen);
  return details.open;
};

export const faqState = isOpen => String(Boolean(isOpen));

// 上下の余白も含めて高さを測ってから動かす。
const measureAnswer = answer => {
  const style = window.getComputedStyle(answer);

  return {
    height: answer.getBoundingClientRect().height,
    marginBlockStart: style.marginBlockStart,
    paddingBlockStart: style.paddingBlockStart,
    paddingBlockEnd: style.paddingBlockEnd,
  };
};

// 縮んでいる間に中身がはみ出さないよう、動いている間だけ隠す。
const CLIPPED = { overflow: "hidden" };

const COLLAPSED = {
  height: 0,
  marginBlockStart: 0,
  paddingBlockStart: 0,
  paddingBlockEnd: 0,
  opacity: 0,
};

const restore = (answer, onComplete) => () => {
  gsap.set(answer, { clearProps: "all" });
  onComplete?.();
};

const animateOpen = (answer, onComplete) => {
  const natural = measureAnswer(answer);

  gsap.set(answer, { ...CLIPPED, ...COLLAPSED });
  gsap.to(answer, {
    ...natural,
    opacity: 1,
    duration: DURATION,
    ease: EASE,
    onComplete: restore(answer, onComplete),
  });
};

const animateClose = (answer, onComplete) => {
  const natural = measureAnswer(answer);

  gsap.set(answer, { ...CLIPPED, ...natural });
  gsap.to(answer, {
    ...COLLAPSED,
    duration: DURATION,
    ease: EASE,
    onComplete: restore(answer, onComplete),
  });
};

if (typeof document !== "undefined") {
  const reducedQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  document.querySelectorAll(".js-faq-item").forEach(details => {
    const summary = details.querySelector(".js-faq-question");
    const answer = details.querySelector(".js-faq-answer");

    if (!summary) return;

    let animating = false;

    const sync = () => {
      summary.dataset.open = faqState(details.open);
    };

    if (!answer || reducedQuery.matches) {
      details.addEventListener("toggle", sync);
      sync();
      return;
    }

    summary.addEventListener("click", event => {
      if (animating) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      animating = true;

      if (details.open) {
        // 閉じ切ってから枠の余白と罫線が戻ると、答えが消えた後も下の項目がずれ続けるため先に戻す。
        details.dataset.closing = "true";
        animateClose(answer, () => {
          details.open = false;
          delete details.dataset.closing;
          sync();
          animating = false;
        });
      } else {
        details.open = true;
        sync();
        animateOpen(answer, () => {
          animating = false;
        });
      }
    });

    sync();
  });
}
